import { LANDING } from "@/constants/testIds";

const CITIES = [
  "NEW YORK",
  "TOKYO",
  "BERLIN",
  "LONDON",
  "SÃO PAULO",
  "SEOUL",
  "LAGOS",
  "MEXICO CITY",
  "PARIS",
  "MUMBAI",
];

export const MarqueeStrip = () => {
  const items = [...CITIES, ...CITIES];
  return (
    <div
      data-testid={LANDING.marquee}
      className="relative border-y border-white/[0.06] bg-[#0a0414] py-5 overflow-hidden"
    >
      <div className="flex w-max animate-[marquee_28s_linear_infinite]">
        {items.map((city, i) => (
          <span
            key={i}
            className="flex items-center gap-6 px-6 shrink-0 text-sm font-display tracking-[0.25em] text-[#7c6a9e]"
          >
            {city}
            <span className="h-1.5 w-1.5 rounded-full bg-[#a259ff]" />
          </span>
        ))}
      </div>
    </div>
  );
};
